// @flow
// ----------------------------------------------------------------------
// <copyright file="Izenda.DashboardTileAction.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//
// </copyright>
// ----------------------------------------------------------------------

/**
 * DashboardTileAction - common actions for all report part in dashboard
 */

import { compose, withHandlers, mapProps } from 'recompose';
import { concat, tail, omit } from 'lodash/fp';

const action = compose(
  withHandlers({
    needUpdatePreview(props: any) {
      const { store, dashboardPart } = props;

      return (...args) => {
        store.onDashboardPartDrillDown(dashboardPart);
        // remove 1st arguments : arguments because it not need in dashboard
        return store.getReportPartData.apply(
          store,
          concat([props.dashboardPart, false], tail(args))
        );
      };
    },
    updateDrillDownInfo(props: any) {
      return () => {
        props.store.onDashboardPartDrillDown(props.dashboardPart);
      };
    },

    getDrillDownRecords(props: any) {
      const store = props.store;

      return (...args) => {
        // remove 1st arguments : report part arguments because it not need in dashboard
        return store.getDrilldownInfo.apply(
          store,
          concat([props.dashboardPart, false], tail(args))
        );
      };
    },
    getFilterInfoForSubReport(props: any) {
      return () => {
        return props.dashboardPart.filterInfoForSubReport();
      };
    }
  }),
  mapProps(props => omit(['store'], props))
);

export default action;



// WEBPACK FOOTER //
// ./ui/modules/Dashboard/DashboardDesigner/DashboardGrid/DashboardTile/ReportPartTile/Izenda.DashboardTileAction.js